import { IconButton } from '@components/iconButton';
import { Refresh } from '@assets/svgs';

interface IExternalIcon {
  isError: boolean;

  onRefresh: () => void;
}

export const ExternalIcon = ({ isError, onRefresh }: IExternalIcon) => {
  if (isError) {
    return (
      <IconButton variant='circularDark' size='small' onClick={() => onRefresh()}>
        <Refresh width='15px' height='15px' />
      </IconButton>
    );
  }
  return null;
};
